<template>
  <div class="pageContain">
    <div @click="fristCurrent(item)" class="row right-border">
      {{ firstTitle }}
    </div>
    <div @click="upCurrent(item)" class="row right-border">{{ upTitle }}</div>
    <div class="midClass">
      <div
        @click="handleCurrent(item)"
        class="item right-border"
        :class="[chooseIndex === item ? 'active' : '']"
        v-for="(item, index) in pageArr"
        :key="index"
      >
        {{ item }}
      </div>
    </div>
    <div @click="downCurrent(item)" class="row">{{ downTitle }}</div>
    <div @click="endCurrent(item)" class="row  left-border">{{ endTitle }}</div>
    
  </div>
</template>

<script>
export default {
  name: "ZhiniPagination",
  props: {
      pagesize:{type: Number},
    currentPage: {
      type: Number,
      default: 1
    },
    totalPage: {
      type: Number,
      default: 12
    },
    showPage: {
      type: Number,
      default: 3
    },
    firstTitle: {
      type: String,
      default: "首页"
    },
    endTitle: {
      type: String,
      default: "尾页"
    },
    upTitle: {
      type: String,
      default: "上一页"
    },
    downTitle: {
      type: String,
      default: "下一页"
    }
  },
  data() {
    return {
      chooseIndex: 1,
      item: 0,
      pageSize:5
    };
  },
  mounted() {
      if(this.pagesize){
          this.pageSize=this.pagesize
      }
      
  },
  watch:{ 
    pagesize:function(newVal){ 
      this.pageSize=this.pagesize=newVal
    }
  },
  computed: {
    pageArr() {
      const totalPage =Math.ceil(this.totalPage/this.pageSize); //总页码
      const currentPage = this.currentPage; //当前页码
      let pageArr = []; //初始化页码数组
      const showPage = this.showPage; //指的是在...和...之间所有的方块div的数目

      //1. 当最大页码 小于 showPage时
      if (totalPage <= showPage) {
        for (let x = 1; x <= totalPage; x++) {
          pageArr.push(x);
        }

        return pageArr;
      }

      // 2. 当最大页码 大于 showPage时

      if (totalPage > showPage) {
        const leftArr = [];
        const isEven = showPage % 2;
        const rightArr = [];
        const midArr = [];
        // showPage 为奇数时

        let startNum = 1;
        let endNum = 0;
        const flagNum = isEven ? (showPage - 1) / 2 : showPage / 2;
        if (currentPage - flagNum > 2) {
          leftArr.push(1);
          leftArr.push("...");
          startNum = currentPage - flagNum;
        }

        endNum = currentPage + flagNum;
        if (endNum > totalPage - 2) {
          endNum = totalPage;
        }

        if (endNum <= totalPage - 2) {
          rightArr.push("...");
          rightArr.push(totalPage);
        }

        for (let x = startNum; x <= endNum; x++) {
          midArr.push(x);
        }

        pageArr = leftArr.concat(midArr, rightArr);
      }

      return pageArr;
    }
  },
  methods: {
    handleCurrent(item) {
      console.log('handleCurrent',item);

      if (item == "...") {
        return;
      }

      this.chooseIndex = item;
      // this.currentPage = item;
      this.$emit("pageNum", item);
      // this.$emit("update:currentPage", item);
    },
    fristCurrent() {
      if (this.currentPage == 1) {
        return;
      }
      this.handleCurrent(1);
    },
    endCurrent() {
      if (this.currentPage == Math.ceil(this.totalPage/this.pageSize)) {
        return;
      }
      this.handleCurrent(Math.ceil(this.totalPage/this.pageSize));
    },
    upCurrent() {
      if (this.currentPage == 1) {
        return;
      }
      this.handleCurrent(this.currentPage - 1);
    },
    downCurrent() {
      if (this.currentPage == Math.ceil(this.totalPage/this.pageSize)) {
        return;
      }
      this.handleCurrent(this.currentPage + 1);
    }
  }
};
</script>

<style scoped>
.pageContain {
  /* display: flex; */
  width: 100%;
  /* justify-content: center; */
  /* background-color: #ffffff; */
  padding: 36px 0 26px;
  text-align: center;
}
.pageContain:hover {
  cursor: pointer;
}
.pageContain > div {
  display: inline-block;
}
.midClass {
  /* display: flex; */
}
.row {
  font-size: 12px;
  text-align: center;
  line-height: 28px;
  height: 28px;
  margin: 0 7px;
  /* padding: 1px 0.03rem; */
  border: 1px solid #c1c1c1;
  padding: 0 14px;
}
.left-radius {
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}
.right-radius {
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
}
.left-border {
  /* border-left: none !important; */
}
.right-border {
  /* border-right: none !important; */
}
.item {
  width: auto;
  padding: 0 14px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border: 1px solid #c1c1c1;
  font-size: 14px;
  border-radius: 4px;
  margin: 0 7px;
  display: inline-block;
}
.active {
  /* background: #00bdff; */
  /* color: #fff; */
  background: rgba(230, 31, 38, 1);
  border: 1px solid rgba(230, 31, 38, 1);
  color: #ffffff;
  border: none;
}
.item,.row{
    height: 40px;
    line-height: 40px;
    min-width: 40px;
}
</style>
